if (!customElements.get('novellaty-series')) {
  customElements.define('novellaty-series', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.config = JSON.parse(this.querySelector('[data-series-config]').textContent);
      this.text = this.config.strings;
      this.mode = 'read';
      const requestedOffer=new URLSearchParams(location.search).get('variant');
      const selectedOffer=this.config.bundles.find(b=>String(b.id)===requestedOffer);
      this.upgradeId=selectedOffer?.kind==='upgrade'?selectedOffer.id:null;
      if(selectedOffer)this.mode=selectedOffer.format;
      this.size = 19;
      this.dialog = this.querySelector('.nvs-sample');
      this.books = this.config.books;
      this.money = new Intl.NumberFormat(this.config.locale || 'en', {style:'currency',currency:this.config.currency});
      this.selected = this.books.find(b=>b.handle===this.dataset.currentBook) || this.books[0];
      this.querySelector('.nvs-format-picker').hidden = ['read','listen','both'].filter(mode=>this.books.some(b=>b.variants.some(v=>v.format===mode))).length < 2;
      this.querySelectorAll('[data-format]').forEach(button=>button.hidden=!this.books.some(b=>b.variants.some(v=>v.format===button.dataset.format)));
      this.railObserver=new ResizeObserver(()=>this.updateRail());
      this.railObserver.observe(this.querySelector('.nvs-book-rail'));
      this.addEventListener('click', event=>this.onClick(event));
      this.querySelector('.nvs-single-form').addEventListener('submit',event=>{
        event.preventDefault();
        const variant=this.variant(this.selected);
        if (variant?.available) this.add([{id:variant.id,quantity:1}],event.submitter || this.querySelector('.nvs-single-buy'));
      });
      this.dialog.addEventListener('close',()=>{
        this.querySelector('[data-audio-player]').pause();
        this.sampleOpener?.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click',event=>{
        if(event.target!==this.dialog)return;
        const r=this.dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();
      });
      this.hashListener=()=>this.readHash();
      window.addEventListener('hashchange',this.hashListener);
      this.readHash(false);
      this.render();
    }
    disconnectedCallback(){window.removeEventListener('hashchange',this.hashListener);this.railObserver?.disconnect();}
    updateRail(){const rail=this.querySelector('.nvs-book-rail');this.querySelector('.nvs-rail-nav').hidden=rail.scrollWidth<=rail.clientWidth+2;}
    variant(book){return book?.variants.find(v=>v.format===this.mode);}
    formatPrice(cents){return this.money.format(cents/100);}
    readHash(render=true){
      const prefix='#book-';
      if(!location.hash.startsWith(prefix))return;
      const handle=decodeURIComponent(location.hash.slice(prefix.length));
      const book=this.books.find(b=>b.handle===handle);
      if(book){this.selected=book;if(!this.variant(book))this.mode='read';if(render)this.render();}
    }
    onClick(event){
      const editionButton=event.target.closest('[data-select-book]');
      if(editionButton){this.selectBook(editionButton.dataset.selectBook,editionButton.dataset.bookFormat);return;}
      const bookLink=event.target.closest('[data-book]');
      if(bookLink){
        event.preventDefault();this.selectBook(bookLink.dataset.book);return;
      }
      const button=event.target.closest('button');if(!button)return;
      if(button.hasAttribute('data-format')){
        this.mode=button.dataset.format;this.upgradeId=null;
        if(!this.variant(this.selected))this.selected=this.books.find(b=>this.variant(b));
        this.render();return;
      }
      if(button.hasAttribute('data-buy-collection')){
        const offer=this.activeOffers.find(o=>String(o.id)===button.dataset.buyCollection);
        if(offer?.available)this.add(offer.items,button);return;
      }
      if(button.hasAttribute('data-show-all')){this.upgradeId=null;const url=new URL(location.href);url.searchParams.delete('variant');history.replaceState(null,'',url);this.render();return;}
      if(button.hasAttribute('data-rail-step')){
        const rail=this.querySelector('.nvs-book-rail');rail.scrollBy({left:Number(button.dataset.railStep)*rail.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});return;
      }
      if(button.hasAttribute('data-motion')){
        const paused=this.classList.toggle('nvs-is-still');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?this.text.play_motion:this.text.pause_motion;return;
      }
      if(button.hasAttribute('data-open-sample')||button.hasAttribute('data-open-audio')){
        this.sampleOpener=button;this.openSample(button.hasAttribute('data-open-audio'));return;
      }
      if(button.hasAttribute('data-close-sample'))this.dialog.close();
      if(button.hasAttribute('data-text-size')){this.size=Math.max(16,Math.min(27,this.size+Number(button.dataset.textSize)*2));this.dialog.style.setProperty('--sample-size',this.size+'px');}
      if(button.hasAttribute('data-reading-theme')){const dark=this.dialog.toggleAttribute('data-dark');button.setAttribute('aria-pressed',String(dark));button.setAttribute('aria-label',dark?this.text.light_reading:this.text.dark_reading);}
    }
    selectBook(handle,format=this.mode){
      const book=this.books.find(b=>b.handle===handle);if(!book)return;
      this.selected=book;
      this.mode=book.variants.some(v=>v.format===format)?format:(book.variants[0]?.format||'read');
      history.replaceState(null,'','#book-'+book.handle);this.render();
      const detail=this.querySelector('.nvs-book-detail');
      detail.focus({preventScroll:true});
      detail.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    render(){
      const status=this.querySelector('[data-status]');
      if(status){status.replaceChildren();this.querySelector('.nvs-delivery').before(status);}
      this.querySelectorAll('[data-format]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.format===this.mode)));
      const offered=this.books.filter(b=>this.variant(b));
      let bundles=this.config.bundles.filter(b=>b.format===this.mode&&(this.upgradeId?b.id===this.upgradeId:b.kind!=='upgrade'));
      if(!bundles.length&&offered.length>1)bundles=[{id:'singles',kind:'full',complete:offered.length===this.books.length,bookNumbers:offered.map(b=>b.number),price:offered.reduce((sum,b)=>sum+this.variant(b).price,0),available:offered.every(b=>this.variant(b).available)}];
      this.activeOffers=[];
      const container=this.querySelector('[data-collections]');container.replaceChildren();
      this.querySelector('[data-show-all]').hidden=!this.upgradeId;
      for(const bundle of bundles){
        const included=this.books.filter(b=>bundle.bookNumbers.includes(b.number));
        const node=this.querySelector('[data-collection-template]').content.firstElementChild.cloneNode(true);
        const kind=bundle.kind||'full';node.dataset.kind=kind;
        const title=kind==='full'?(bundle.complete?this.text.full:this.text.available_collection):this.text[kind];
        node.querySelector('[data-collection-title]').textContent=title;
        node.querySelector('[data-collection-kicker]').textContent=this.text[(kind==='full'&&!bundle.complete?'available':kind)+'_kicker'];
        node.querySelector('[data-collection-price]').textContent=this.formatPrice(bundle.price);
        const numbers=included.map(b=>b.number),consecutive=numbers.every((n,i)=>i===0||n===numbers[i-1]+1);
        const range=numbers.length===1?String(numbers[0]):consecutive?numbers[0]+'–'+numbers.at(-1):numbers.join(', ');
        const bookRange=document.createElement('strong');
        bookRange.textContent=(numbers.length===1?this.text.book:this.text.books)+' '+range;
        node.querySelector('[data-collection-summary]').replaceChildren(bookRange,document.createTextNode(' · '+this.text['format_'+this.mode]));
        node.querySelector('[data-included-books]').replaceChildren(...included.map(b=>{const li=document.createElement('li');li.value=b.number;li.textContent=b.title;return li;}));
        const singles=included.reduce((sum,b)=>sum+(this.variant(b)?.price||0),0),saving=singles-bundle.price;
        const savingNode=node.querySelector('[data-collection-saving]');savingNode.hidden=saving<=0;savingNode.textContent=this.text.save.replace('{amount}',this.formatPrice(saving));
        const button=node.querySelector('[data-buy-collection]');button.dataset.buyCollection=String(bundle.id);button.textContent=bundle.available?this.text.add_collection+' · '+this.formatPrice(bundle.price):this.text.available_soon;button.disabled=!bundle.available;
        const upgrade=this.config.bundles.find(b=>b.format===this.mode&&b.kind==='upgrade');
        const note=node.querySelector('[data-upgrade-note]');
        const showUpgrade=kind==='starter'&&upgrade;note.hidden=!showUpgrade;
        note.textContent=showUpgrade?this.text.upgrade_note.replace('{amount}',this.formatPrice(upgrade.price)):'';
        this.activeOffers.push({...bundle,items:bundle.id==='singles'?included.map(b=>({id:this.variant(b).id,quantity:1})):[{id:bundle.id,quantity:1}]});container.append(node);
      }
      this.renderBook();requestAnimationFrame(()=>this.updateRail());
    }
    renderBook(){
      const book=this.selected;if(!book)return;
      this.querySelectorAll('[data-book-card]').forEach(card=>card.classList.toggle('is-selected',card.dataset.bookCard===book.handle));
      this.querySelectorAll('[data-book]').forEach(link=>{if(link.dataset.book===book.handle)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
      this.querySelectorAll('[data-select-book]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.selectBook===book.handle&&button.dataset.bookFormat===this.mode)));
      this.querySelector('[data-book-number]').textContent=this.text.book+' '+book.number;
      this.querySelector('#nvs-book-title').textContent=book.title;
      this.setParagraphs(this.querySelector('[data-book-synopsis]'),book.synopsis);
      const variant=this.variant(book),note=this.querySelector('[data-audio-note]');
      this.querySelector('[data-selected-edition]').textContent=this.text['edition_'+this.mode]+(variant?' · '+this.formatPrice(variant.price):'');
      note.textContent=[book.audioDuration,book.narration].filter(Boolean).join(' · ');note.hidden=this.mode==='read'||!note.textContent;
      this.querySelectorAll('[data-open-sample]').forEach(button=>button.hidden=!book.sample?.length);
      this.querySelectorAll('[data-open-audio]').forEach(button=>button.hidden=!book.audioSample||this.mode==='read');
      this.querySelectorAll('[data-preview-title]').forEach(label=>label.textContent=book.title);
      this.querySelectorAll('.nvs-sample-actions').forEach(group=>group.hidden=!book.sample?.length&&(!book.audioSample||this.mode==='read'));
      this.querySelector('[data-single-price]').textContent=variant?this.formatPrice(variant.price):'';
      this.querySelector('[data-single-label]').textContent=variant?.available?this.text['add_'+this.mode]:this.text.available_soon;
      this.querySelector('.nvs-single-form input[name=id]').value=variant?.id||'';
      this.querySelector('.nvs-single-buy').disabled=!variant?.available;
    }
    setParagraphs(node,paragraphs){node.replaceChildren(...(paragraphs||[]).map(text=>{const p=document.createElement('p');p.textContent=text;return p;}));}
    openSample(audio=false){
      const book=this.selected;this.querySelector('[data-sample-book]').textContent=book.title;
      this.querySelector('#nvs-sample-title').textContent=audio?this.text.listen_sample:book.sampleHeading;
      const text=this.querySelector('[data-sample-text]'),player=this.querySelector('[data-audio-player]');
      text.hidden=audio;player.hidden=!audio;
      if(audio){player.src=book.audioSample;}else this.setParagraphs(text,book.sample);
      this.querySelector('.nvs-sample-tools').hidden=audio;
      this.dialog.showModal();this.dialog.scrollTop=0;
    }
    static cartQueue = Promise.resolve();
    async addSelection(items){
      const request=async()=>{
        const getJson=async(url,options={})=>{
          const response=await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
          const data=await response.json();
          if(!response.ok)throw new Error(data.description||this.text.cart_error);
          return data;
        };
        const post=data=>({method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)});
        const digitalIds=new Set([...this.config.books.flatMap(book=>book.variants),...this.config.bundles].filter(v=>v.requiresShipping===false).map(v=>String(v.id)));
        const requested=new Map();
        for(const item of items){
          const key=String(item.id),digital=digitalIds.has(key);
          requested.set(key,{...item,quantity:digital?1:(requested.get(key)?.quantity||0)+item.quantity});
        }
        let cart=await getJson(this.config.cartUrl+'.js');
        const updates={};
        for(const id of requested.keys()){
          if(!digitalIds.has(id))continue;
          const matches=cart.items.filter(item=>String(item.variant_id)===id);
          if(matches.reduce((n,item)=>n+item.quantity,0)>1){
            matches.forEach((item,index)=>updates[item.key]=index===0?1:0);
          }
        }
        if(Object.keys(updates).length)cart=await getJson(this.config.cartUrl+'/update.js',post({updates}));
        const pending=[...requested.values()].filter(item=>!digitalIds.has(String(item.id))||!cart.items.some(line=>String(line.variant_id)===String(item.id)));
        if(!pending.length)return {cart,already:true};
        try{
          await getJson(this.config.addUrl,post({items:pending}));
          cart=await getJson(this.config.cartUrl+'.js');
        }catch(error){throw new Error(this.text.check_bookbag);}
        return {cart,already:false};
      };
      const run=()=>navigator.locks?.request?navigator.locks.request('novellaty-bookbag',request):request();
      const job=this.constructor.cartQueue.then(run,run);
      this.constructor.cartQueue=job.catch(()=>{});
      return job;
    }
    async add(items,button){
      if(this.adding)return;
      this.adding=true;button.disabled=true;button.setAttribute('aria-busy','true');
      const previous=button.textContent;button.textContent=this.text.adding;
      const status=this.querySelector('[data-status]');status.replaceChildren();
      button.after(status);
      const showStatus=(message)=>{
        if(!status.isConnected)this.querySelector('.nvs-delivery').before(status);
        status.replaceChildren();
        const title=document.createElement('span');title.className='nvs-status-message';title.textContent=message;
        const link=document.createElement('a');link.href=this.config.cartUrl;link.textContent=this.text.view_bookbag;
        status.append(title,link);
      };
      try{
        const {cart,already}=await this.addSelection(items);
        showStatus(already?this.text.already_in_bookbag:this.text.added);
        document.querySelectorAll('[data-cart-count]').forEach(count=>count.textContent=String(cart.item_count));
      }catch(error){showStatus(error.message||this.text.cart_error);}
      finally{
        this.adding=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=previous;
        if(button.classList.contains('nvs-single-buy')){
          button.replaceChildren();const label=document.createElement('span'),price=document.createElement('span');
          label.dataset.singleLabel='';price.dataset.singlePrice='';button.append(label,price);this.renderBook();
        }
      }
    }
  });
}
